<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Sentiment Models
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="sentiment-models/add" v-if="$auth.user().AuthScope.includes('sentiment:manage')">
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="custom_headers"
            :items="custom_models"
            hide-actions
            :loading="sentimentModelListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.language.name }}</td>
                <td class="text-xs-right">
                  <v-tooltip bottom color="grey">
                    <v-icon
                      class="mr-2"
                      color="grey"
                      slot="activator"
                      @click="$router.push({name: 'sentimentModelExport', params: {id: props.item.id, name: props.item.name}})"
                    >
                      cloud_download
                    </v-icon>
                    <span>Export Sentiment Model</span>
                  </v-tooltip>
                  <v-tooltip bottom color="success" v-if="!props.item.is_vanilla">
                    <v-icon
                      class="mr-2"
                      color="success"
                      slot="activator"
                      @click="$router.push(`/sentiment-models/${props.item.id}/statistics`)"
                    >
                      insert_chart
                    </v-icon>
                    <span>Show Statistics</span>
                  </v-tooltip>
                  <v-tooltip bottom color="secondary">
                    <v-icon
                      class="mr-2"
                      color="secondary"
                      slot="activator"
                      @click="$router.push(`/sentiment-models/${props.item.id}/try`)"
                    >
                      directions_run
                    </v-icon>
                    <span>Try Model</span>
                  </v-tooltip>
                  <v-tooltip bottom color="accent" v-if="$auth.user().AuthScope.includes('sentiment:manage') && !props.item.is_vanilla">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/sentiment-models/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error" v-if="$auth.user().AuthScope.includes('sentiment:manage') && !props.item.is_vanilla">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      max-width="500"
      v-if="$auth.user().AuthScope.includes('sentiment:manage')"
    >
      <v-card>
        <v-card-title class="headline">Delete Sentiment Model</v-card-title>
        <v-card-text>
          Are you sure to delete this Sentiment Model?
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      custom_headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Language', sortable: true, value: 'language'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      custom_models: [],
      dialog: false,
      itemToDelete: {},
      deleteLoading: false,
      sentimentModelListLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  created () {
    this.sentimentModelListLoading = true
    this.fetchSentimentModels()
  },
  methods: {
    fetchSentimentModels () {
      this.axios.get('/sentiment-models')
        .then(response => {
          response.data.custom_models.forEach(sentimentModel => {
            this.custom_models.push({
              id: sentimentModel.id,
              name: sentimentModel.name,
              language: sentimentModel.language,
              is_vanilla: sentimentModel.is_vanilla
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.sentimentModelListLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/sentiment-models/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.custom_models.indexOf(this.itemToDelete)
          this.custom_models.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    }
  }
}
</script>

<style>

</style>
